import { InjectionToken } from '@angular/core';

export interface AppConfig {
  production: boolean;
  sentryLogging: boolean;
  enableSEO: boolean;
  consoleUrl?: string;
}

export const DEFAULT_APP_CONFIG: AppConfig = {
  production: false,
  sentryLogging: false,
  enableSEO: false,
};

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG', {
  providedIn: 'root',
  factory: (): AppConfig => DEFAULT_APP_CONFIG,
});
